export default __webpack_public_path__ + "static/media/ic_merchangdising_reward.596a3406.svg";